module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "overwrite-left"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    },
    slot: "overwrite-left"
  }, [_vm._v(" 关闭")]), _vm._v("\n    重设密码\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('group', {
    staticStyle: {
      "margin": "0 0.1rem",
      "border-radius": "0.3rem"
    },
    attrs: {
      "label-width": "8em"
    }
  }, [_c('cell', {
    attrs: {
      "title": "登录用户名",
      "value-align": "left",
      "value": _vm.name
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "label-width": "8em",
      "title": "输入新密码",
      "placeholder": "请输入",
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "label-width": "8em",
      "title": "确认新密码",
      "placeholder": "请输入",
      "type": "password"
    },
    model: {
      value: (_vm.cpassword),
      callback: function($$v) {
        _vm.cpassword = $$v
      },
      expression: "cpassword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-muted",
    staticStyle: {
      "font-size": "0.24rem",
      "padding-left": "0.12rem",
      "margin-top": "0.2rem"
    }
  }, [_vm._v("\n      请输入8~32位密码(必须包含大写字母和小写字母和数字)\n    ")]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": "0.2rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert-warn margin-bottom-20 domain-list"
  }, [_c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("Windows系统修改密码后大约30秒左右生效。")]), _vm._v(" "), _c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("Linux修改密码需要重新启动两次，大约需要3-5分钟生效 。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72f51a20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/serveroperate/resetpassword.vue
// module id = qs5e
// module chunks = 1